module.exports = __webpack_public_path__ + "static/img/Hhhbb.78c782d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Hhhbb.jpg
// module id = SSMj
// module chunks = 1